/* global TENANT_NAME, CLIENT_ID, REDIRECT_URI, msal, LOCALE */

const config = {
  auth: {
    clientId: CLIENT_ID,
    authority: `https://${TENANT_NAME}.b2clogin.com/${TENANT_NAME}.onmicrosoft.com/B2C_1A_SIGNUP_SIGNIN`,
    knownAuthorities: [`${TENANT_NAME}.b2clogin.com`],
    redirectUri: `${REDIRECT_URI}`,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
    claimsBasedCachingEnabled: true,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return
        }
        switch (level) {
          case msal.LogLevel.Error:
            console.error(message)
        }
      },
    },
  },
}

const loginRequest = {
  // prompt: 'login', -- this was specified by Beterna but makes the login not transfer to new tabs and between booking/www
  // "openid", "profile",
  scopes: [`https://${TENANT_NAME}.onmicrosoft.com/api/base`],
  extraQueryParameters: {
    ui_locales: LOCALE === 'si' ? 'sl' : LOCALE,
  },
}

const signUpRequest = {
  authority: `https://${TENANT_NAME}.b2clogin.com/${TENANT_NAME}.onmicrosoft.com/B2C_1A_SIGNUPEMAIL`,
  prompt: 'login',
  scopes: [`https://${TENANT_NAME}.onmicrosoft.com/api/base`],
  extraQueryParameters: {
    ui_locales: LOCALE === 'si' ? 'sl' : LOCALE,
  },
}

export { loginRequest, config, signUpRequest }
